import { commonTypes } from '../common';
import { addAddressesWithNoDuplicates } from '../normalizers/uiNeeds';

const types = {
  SET_CURRENT_DATE: 'APISNEEDS/SET_CURRENT_DATE',
};

export const initialState = {
  myProductsInfo: null,
  parentProductIdSelected: null,
};

const ApisNeedsMyProductsReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_MY_PRODUCTS_INFO: {
      const {
        convergentMainPoId,
        convergentProductId,
        netflixPoId,
        netflixModality,
        tvProductId,
        tvProducts,
        linesMobile,
        linesPhone,
        addresses,
        clientCategory,
        rawData,
      } = action.payload;

      const newAddressesArray = addAddressesWithNoDuplicates(state.clientAddresses, addresses);

      return {
        ...state,
        myProductsInfo: {
          ...state.myProductsInfo,
          convergentMainPoId,
          convergentProductId,
          netflixPoId,
          netflixModality,
          tvProductId,
          tvProducts,
          linesMobile,
          linesPhone,
          newAddressesArray,
          clientCategory,
          rawData,
        },
        clientAddresses: newAddressesArray,
      };
    }
    case commonTypes.SET_PARENT_PRODUCT_SELECTED: {
      const { productSelected } = action.payload;

      if (productSelected
        && productSelected.id
      ) {
        return {
          ...state,
          parentProductIdSelected: productSelected.id,
        };
      }

      return {
        ...state,
      };
    }
    case commonTypes.SET_PARENT_PRODUCTS_TO_SELECT: {
      const { parentProducts } = action.payload;

      if (parentProducts
        && Array.isArray(parentProducts)
        && parentProducts.length === 1
      ) {
        return {
          ...state,
          parentProductIdSelected: parentProducts[0].id,
        };
      }

      return {
        ...state,
      };
    }
    case types.SET_CURRENT_DATE: {
      const { date } = action.payload;
      
      return {
        ...state,
        currentDate: date,
      };

    }
    default:
      return null;
  }
};

export const actions = {
  setCurrentDate: date => ({
    type: types.SET_CURRENT_DATE,
    payload: {
      date,
    },
  }),
};

export default ApisNeedsMyProductsReducer;
